export default __webpack_public_path__ + "static/media/discord.99856f62.svg";